module.exports = __webpack_public_path__ + "static/NOI1-9347df9738dd93b93461b54d5730bf7b.jpg";